import { can, clinicUsersAdapter, UsersPage } from '@pa/staff'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useMemo } from 'react'

/**
 * C-13 Users, with C-13a and C-13b as dialogs (UserFlows C-13; Frontend §6.1, §6.3): the shared `@pa/staff` `users`
 * feature over the clinic adapter (#31–#35). Guard row 6 (Frontend §5.3): the `users.manage` capability (Clinic
 * Admins; an impersonating super admin counts as one, task 13). A Clinic User is sent to C-01 (P-08: hidden).
 */
export const Route = createFileRoute('/_authed/clinics/$clinicId/users')({
  beforeLoad: ({ context, params }) => {
    if (!can('users.manage', { role: context.role })) {
      redirect({
        to: '/clinics/$clinicId/appointments',
        params: { clinicId: params.clinicId },
        replace: true,
        throw: true,
      })
    }
  },
  component: function UsersRoute() {
    const { clinicId } = Route.useParams()
    const adapter = useMemo(() => clinicUsersAdapter(clinicId), [clinicId])
    return <UsersPage adapter={adapter} />
  },
})
